import { FC, HTMLProps } from 'react';
import cx from 'classnames';

import styles from './Layout.module.scss';

export type LayoutFooterProps = Pick<HTMLProps<HTMLDivElement>, 'className'> & {};

const LayoutFooter: FC<LayoutFooterProps> = ({ children, className, ...htmlProps }): JSX.Element => (
  <div className={cx(className, styles.footer)} {...htmlProps}>
    {children}
  </div>
);

export default LayoutFooter;
